import { render, staticRenderFns } from "./CompanyUserCreate.vue?vue&type=template&id=38ad1ea3"
import script from "./CompanyUserCreate.vue?vue&type=script&lang=ts"
export * from "./CompanyUserCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports